module.exports = __webpack_public_path__ + "img/granada.caebad3a.jpg";